import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment.development';

export interface InscripcionResponse {
  ok: boolean;
  msg?: string;
  data?: any;
}

export interface ProgresoClase {
  id_clase: number;
  titulo_clase: string;
  orden: number;
  completada: boolean;
  fecha_completado: string | null;
}

export interface ProgresoModulo {
  id_modulo: number;
  titulo_modulo: string;
  total_clases: number;
  clases_completadas: number;
  porcentaje: number;
  clases: ProgresoClase[];
}

export interface ProgresoCurso {
  id_curso: number;
  titulo_curso: string;
  total_modulos: number;
  total_clases: number;
  clases_completadas: number;
  porcentaje_general: number;
  modulos: ProgresoModulo[];
}

export interface ProgresoCursoResponse {
  ok: boolean;
  data?: ProgresoCurso;
  msg?: string;
}

export interface ClaseDetalle {
  id_clase: number;
  id_modulo: number;
  titulo_clase: string;
  descripcion: string | null;
  tipo_contenido: string;
  url_video: string;
  duracion_minutos: number | null;
  contenido_blog: string | null;
  foto_portada: string | null;
  tiempo_lectura_minutos: number | null;
  orden: number;
  modulo: {
    id_modulo: number;
    titulo_modulo: string;
    id_curso: number;
    curso: {
      id_curso: number;
      titulo: string;
      id_maestro: number;
    };
  };
  actividades: any[];
  recursos: any[];
}

export interface ClaseDetalleResponse {
  ok: boolean;
  data?: ClaseDetalle;
  msg?: string;
}

@Injectable({
  providedIn: 'root'
})
export class InscripcionesService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Inscribe al usuario en un curso
   */
  inscribirse(idCurso: number): Observable<InscripcionResponse> {
    return this.http.post<InscripcionResponse>(`${this.API_URL}/inscripciones/inscribirse`, {
      id_curso: idCurso
    }).pipe(
      tap(response => {
        console.log('Inscripción:', response);
      }),
      catchError(error => {
        console.error('Error al inscribirse:', error);
        return of({
          ok: false,
          msg: error.error?.msg || 'Error al inscribirse en el curso'
        });
      })
    );
  }

  /**
   * Obtiene el progreso del usuario en un curso específico
   */
  getProgresoCurso(idCurso: number): Observable<ProgresoCursoResponse> {
    return this.http.get<ProgresoCursoResponse>(`${this.API_URL}/progreso/curso/${idCurso}`).pipe(
      tap(response => {
        console.log('Progreso del curso:', response);
      }),
      catchError(error => {
        console.error('Error al obtener progreso:', error);
        return of({
          ok: false,
          msg: error.error?.msg || 'Error al cargar el progreso del curso'
        });
      })
    );
  }

  /**
   * Marca una clase como completada
   */
  completarClase(idClase: number): Observable<InscripcionResponse> {
    return this.http.post<InscripcionResponse>(`${this.API_URL}/progreso/clase/${idClase}/completar`, {}).pipe(
      tap(response => {
        console.log('Clase completada:', response);
      }),
      catchError(error => {
        console.error('Error al completar clase:', error);
        return of({
          ok: false,
          msg: error.error?.msg || 'Error al marcar la clase como completada'
        });
      })
    );
  }

  /**
   * Obtiene los detalles de una clase específica
   */
  getClaseDetalle(idClase: number): Observable<ClaseDetalleResponse> {
    return this.http.get<ClaseDetalleResponse>(`${this.API_URL}/clases/${idClase}`).pipe(
      tap(response => {
        console.log('Detalle de clase:', response);
      }),
      catchError(error => {
        console.error('Error al obtener clase:', error);
        return of({
          ok: false,
          msg: error.error?.msg || 'Error al cargar los detalles de la clase'
        });
      })
    );
  }
}


